import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    packages: [],
};

export const packagesSlice = createSlice({
    name: 'packagesSlice',
    initialState,
    reducers: {
        // a- getting customers for organization admin 
        getAllPackages: (state, action) => {
            state.packages = action.payload;
        },
       
    },
});

// Action creators are generated for each case reducer function
export const { getAllPackages } = packagesSlice.actions;

export default packagesSlice.reducer;
